import {Label, Link} from '@primer/react'

import type {SemanticSearchFeaturePreview as SemanticSearchFeaturePreviewState} from '../../hooks/use-issues-index-semantic-search-toggle-feature-preview'
import styles from './SemanticSearchFeaturePreview.module.css'

const STAFF_DOCS_LINK = 'https://gh.io/semantic-issues-search-staff'
const STAFF_FEEDBACK_LINK = 'https://gh.io/semantic-issues-search-feedback-staff'
const EXTERNAL_DOCS_LINK = 'https://gh.io/semantic-issues-search'
const EXTERNAL_FEEDBACK_LINK = 'https://gh.io/semantic-issues-search-feedback'

export function SemanticSearchFeaturePreview({isAvailable, isEnabled, isStaff}: SemanticSearchFeaturePreviewState) {
  const docsLink = isStaff ? STAFF_DOCS_LINK : EXTERNAL_DOCS_LINK
  const feedbackLink = isStaff ? STAFF_FEEDBACK_LINK : EXTERNAL_FEEDBACK_LINK

  // Don't show anything if feature flag is disabled or user is not enrolled
  if (!isAvailable || !isEnabled) {
    return null
  }

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footerContainer}>
        <Label variant="success">Preview</Label>
        <div className={styles.footerLinks}>
          <span>
            <Link inline href={docsLink} target="_blank" rel="noopener noreferrer">
              Semantic search
            </Link>
            {' enabled'}
          </span>
          <span className={styles.separator} aria-hidden="true">
            ·
          </span>
          <Link inline href={feedbackLink} target="_blank" rel="noopener noreferrer">
            Give feedback
          </Link>
        </div>
      </div>
    </div>
  )
}
